import { useMemo, useState } from "react";
import { WrenchIcon } from "lucide-react";
import { Button } from "@devhop/ui";
import type { QiCatalogServiceDTO } from "../api/catalog-types";
import { QiServiceCatalogDialog } from "./QiServiceCatalogDialog";

export function QiServicePicker({
  value,
  label,
  onSelect,
  disabled,
}: {
  value: string;
  label?: string;
  onSelect: (service: QiCatalogServiceDTO) => void;
  disabled?: boolean;
}) {
  const [open, setOpen] = useState(false);
  const [picked, setPicked] = useState<QiCatalogServiceDTO | null>(null);

  const display = useMemo(() => {
    if (label) return label;
    if (picked?.id === value) return `${picked.code} — ${picked.name}`;
    return value ? value : "ເລືອກບໍລິການ...";
  }, [label, picked, value]);

  return (
    <>
      <Button
        type="button"
        variant="outline"
        disabled={disabled}
        className={`h-9 w-full justify-start font-normal ${!value && !label ? "text-muted-foreground" : ""}`}
        onClick={() => setOpen(true)}
      >
        <WrenchIcon className="mr-2 h-4 w-4 shrink-0 opacity-60" />
        <span className="truncate">{display}</span>
      </Button>
      <QiServiceCatalogDialog
        open={open}
        onOpenChange={setOpen}
        selectedId={value || undefined}
        onSelect={(service) => {
          setPicked(service);
          onSelect(service);
        }}
      />
    </>
  );
}
